import { useStructureContext } from "../../../../context/StructureContext";
import { stdObject } from "../../../../data/types/stdObject";
import { getRealCode } from "../../../../utils/getRealCode";
import { useTranslation } from "react-i18next";

export default function SearchInputType({
  data,
  code,
  TITCAB,
  changeValue,
  getValue,
}: {
  data: stdObject;
  code: string;
  TITCAB: number;
  changeValue: (data: stdObject) => void;
  getValue: (value: string, code?: string) => any;
}) {
  const { section } = useStructureContext();
  const { t } = useTranslation();

  const stdSelect = (valueKey: string) => (
    <select
      value={getValue(valueKey, code)}
      onInput={(e) => {
        const target = e.target as HTMLInputElement;
        changeValue({ key: code, value: target.value, valueKey });
      }}
    >
      {data.options.map((e: stdObject, index: number) => (
        <option key={index} value={e.value}>
          {e.label}
        </option>
      ))}
    </select>
  );

  const stdInput = (valueKey: string) => (
    <input
      value={getValue(valueKey, code)}
      onChange={(e) => changeValue({ value: e.target.value, valueKey })}
      type={
        data.type === "oneDate"
          ? "date"
          : data.type === "numberRange"
            ? "number"
            : data.type
      }
      placeholder={
        TITCAB === 0 ? t(`c.${getRealCode(code, section.code)}`) : ""
      }
      style={{
        width: ["numberRange", "number"].includes(data.type)
          ? 50
          : data.type === "text"
            ? 100
            : undefined,
      }}
    />
  );

  switch (data.type) {
    case "select":
      return stdSelect("value");
    case "numberRange":
    case "time":
    case "date":
      return (
        <div>
          {stdInput("value")}
          <span style={{ fontSize: 12 }}> {t("p.until")} </span>
          {stdInput("value2")}
          {data.options && (
            <span style={{ marginLeft: 3 }}>{stdSelect("option")}</span>
          )}
        </div>
      );
    default:
      return stdInput("value");
  }
}
